import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=05bb7084"
import script from "./Wrapper.vue?vue&type=script&lang=js"
export * from "./Wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05bb7084')) {
      api.createRecord('05bb7084', component.options)
    } else {
      api.reload('05bb7084', component.options)
    }
    module.hot.accept("./Wrapper.vue?vue&type=template&id=05bb7084", function () {
      api.rerender('05bb7084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operations/workshop/Wrapper.vue"
export default component.exports